import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Input from '../utils/Input';
import { setTagEdit, fetchTag, updateTag } from '../../action/handbook';
import cn from 'classnames';
import Loader from '../utils/Loader';
import ErrorContainer from '../utils/ErrorContainer';
import { setUIvisible } from '../../action/UImobile';

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

class EditTag extends Component {
    componentWillUnmount() {
        this.props.setTagEdit(null);
    }

    componentDidMount() {
        this.props.fetchTag(this.props.match.params.id).then(tag => {
            this.props.setTagEdit(tag);
        });
        this.props.setUIvisible(false, false);
    }
    
    renderSubHeader() {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">{this.props.edit.name ? this.props.edit.name : 'Введите название отметки *'}</h3>
                    <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                </div>        
                <div className="kt-subheader__toolbar">
                    <button onClick={() => this.props.history.push('/handbook/tags')} className="btn btn-default btn-bold">
                        Назад
                    </button>
                </div>
            </div>
            </div>
        );
    }

    isValidTag() {
        const { name } = this.props.edit;
        if (name) return true;
        
        return false;
    }

    setPayment = (field) => (e) => {        
        const data = {...this.props.edit};
        data[field] = e.target.value;
        this.props.setTagEdit(data);
    }

    onSubmit = (e) => {
        e.preventDefault();
        const edited = { ...this.props.edit };
        this.props.updateTag(this.props.match.params.id, edited).then(result => {
            if (result) {
                this.props.history.push('/handbook/tags');
            }
        });        
    }

    render() {
        const { loading, edit } = this.props;
        if (loading || !edit) {
            return (
                <div style={styles.loading}><Loader/></div>
            );
        }

        return (
            <Fragment>
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                <form onSubmit={this.onSubmit} className="kt-form">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body">
                            <div className="row">
                                <div className="col-md-6">
                                    <Input
                                        label="Отметка"
                                        required={true}
                                        onChange={this.setPayment('name')}
                                        value={edit.name}
                                        placeholder="Название..."
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="kt-portlet">
                        <ErrorContainer field="editTag" style={{ margin: '0 20px 20px' }} hasCloseButton={true}/>
                        <div className="kt-portlet__foot">
                            <div className="kt-form__actions">
                                <button
                                    disabled={!this.isValidTag() || this.props.loading}
                                    type="submit"
                                    className={cn({ 'btn btn-brand  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': this.props.editTagLoader })}>
                                    Сохранить
                                </button>
                            </div>
                        </div>
                    
                </div>
                </form>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    edit: state.handbook.tag.edit,
    loading: state.loaders.tags,
    editTagLoader: state.loaders.editTag
});

const mapDispatchToProps = {
    setTagEdit: (data) => setTagEdit(data),
    fetchTag: (id) => fetchTag(id),
    updateTag: (id, data) => updateTag(id, data),
    setUIvisible: (visibleFiltersButton, visibleActionButton) => setUIvisible(visibleFiltersButton, visibleActionButton)
}

export default connect(mapStateToProps, mapDispatchToProps)(EditTag);